import { faChevronRight } from "@jewlr/pro-solid-svg-icons/faChevronRight"
import {
  Box,
  Button,
  Flex,
  FontAwesomeIcon,
  Image,
  MediaBox,
  Typography,
} from "@jewlr/storybook/core"
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { handleLiveChat, isHelpScout } from "live-chat"

import { SectionTitle, FooterLink } from "./components"
import getFooterData from "./data"
import FooterContentMobile from "./footer-content-mobile"

const ContactText = styled(Typography).attrs({
  color: "white",
  fontSize: { _: "20px", tablet: "14px" },
  fontWeight: { _: "400", tablet: "500" },
  lineHeight: { _: "100%", tablet: "18px" },
  pb: { _: " 12px", tablet: 0 },
})``

const FooterButton = styled(Button).attrs((props) => ({
  bg: "primary",
  color: "white",
  display: "flex",
  fontSize: "16px",
  fontWeight: "600",
  height: "44px",
  width: { _: "100%", desktop: "170px", widescreen: "236px" },
  ...props,
}))`
  line-height: 100%;
  &:focus {
    color: ${(props) => props.theme.colors.white};
    outline-color: ${(props) => props.theme.colors.white};
  }
  &:hover {
    color: ${(props) => props.theme.colors.white};
  }
`

const FooterContent = () => {
  const [isHelpScoutLoaded, setIsHelpScoutLoaded] = useState(false)
  const footerData = getFooterData()

  useEffect(() => {
    if (isHelpScout()) {
      setIsHelpScoutLoaded(true)
    }
  }, [])

  return (
    <Flex
      alignItems="flex-start"
      containWide
      justifyContent="space-between"
      pb={{ _: "10px", tablet: 8 }}
      px={{ _: 2, tablet: "60px" }}
    >
      <Image
        alt="Jewlr"
        mr={{ _: 3, desktop: 0 }}
        mt={{ _: "20px", desktop: 0 }}
        ratio="194 / 240"
        src={require("images/layout/logo/jewlr-icon-logo-white.svg")}
        width={{ _: "48px", desktop: "64px" }}
      />
      <Box
        display={{ _: "block", tablet: "grid" }}
        gridGap={{ tablet: 2, xlarge: 4 }}
        gridTemplateColumns={{ tablet: "repeat(4, 1fr)" }}
        width={{ _: "100%", tablet: "auto" }}
      >
        {footerData.map((data, i) => (
          <Box key={`footersection_${i}`}>
            <FooterContentMobile data={data} />
            <MediaBox greaterThanOrEqual="tablet">
              <SectionTitle as="h2" mb={3}>
                {data.title}
              </SectionTitle>
              {data.links
                .filter((link) => typeof link.show === "undefined" || link.show)
                .map((link, i) => (
                  <FooterLink
                    data-cy={`footer-link-${link.name}`}
                    data-lc="footer"
                    key={`fotterlinke_${i}`}
                    to={link.url}
                    {...link.options}
                  >
                    {link.name}
                  </FooterLink>
                ))}
            </MediaBox>
          </Box>
        ))}
        <Box pt={{ _: 3, tablet: 0 }} px={{ _: 2, tablet: 0 }}>
          <SectionTitle as="h2" mb={{ _: 4, tablet: 3 }}>
            CUSTOMER CARE
          </SectionTitle>
          <FooterLink
            data-lc="footer"
            display="inline-flex"
            mb={{ _: 4, tablet: 2 }}
            to="/helpdesk/contact"
          >
            Order Help Page
            <FontAwesomeIcon
              color="white"
              fontSize="9px"
              icon={faChevronRight}
              ml="4px"
            />
          </FooterLink>
          <Box mb={{ _: 4, tablet: 2 }}>
            <ContactText>Contact Us</ContactText>
            <ContactText>Monday to Sunday</ContactText>
            <ContactText>9am to 5:30pm EST</ContactText>
          </Box>
          <FooterLink
            as="a"
            data-lc="footer"
            display="inline-flex"
            fontSize={{ _: "20px", tablet: "18px" }}
            fontWeight="600"
            href={`tel:${sl.config.customer_service_toll_free}`}
            mb={3}
          >
            {sl.config.customer_service_toll_free}
          </FooterLink>
          <FooterButton
            data-cy="footer-customer-care-contact-us"
            data-lc="footer"
            forwardedAs={Link}
            mb={2}
            to="/helpdesk/contact"
          >
            Contact Us
          </FooterButton>
          {isHelpScoutLoaded && (
            <FooterButton
              onClick={() => {
                handleLiveChat()
              }}
            >
              Live Chat
            </FooterButton>
          )}
        </Box>
      </Box>
    </Flex>
  )
}

export default FooterContent
